<template>
  <FormContainer
    class="CrefazPreSelectForm"
    :add-back-click-listener="false"
    :on-back-click="onBackClick"
    redirect-to-path="/ofertas"
  >
    <InteractiveForm
      ref="rfCrefazPreSelectOfferForm"
      :steps="steps"
      :busy="busy"
      :auto-selectable-steps="autoSelectableSteps"
      @submit="submit"
    >
      <template #default="{ step, validation }">
        <HowItWorks
          v-if="displayInput(step, 'howItWorks')"
          :icon-name="'hand-money-mono'"
          :title="'Entenda o empréstimo na conta de luz'"
          :description="'Com essa modalidade, você solicita o crédito pessoal e as parcelas são cobradas direto na sua conta de luz.'"
          :steps="[
            'Nosso time de atendimento fará a sua simulação de crédito.',
            'Forneça RG/CPF ou CNH e a fatura de energia no seu nome..',
            'Baixe o app da Crefaz e siga as instruções para finalizar a contratação.',
          ]"
          @continue="handleHowItWorks"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'acceptPaymentTerms')"
          id="acceptPaymentTerms"
          key="acceptPaymentTerms"
          v-model="fields.acceptPaymentTerms"
          name="acceptPaymentTerms"
          label="A parcela do empréstimo será incluída na sua conta de luz. Você está ciente dessa forma de pagamento?"
          :validation="validation"
          @input="handleAcceptTerms"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'hasAccount')"
          id="hasAccount"
          key="hasAccount"
          v-model="fields.hasAccount"
          name="hasAccount"
          label="Você possui uma conta de luz cadastrada no seu nome?"
          :validation="validation"
          @input="handleHasAccount"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'hasAccountMoreThan90Days')"
          id="hasAccountMoreThan90Days"
          key="hasAccountMoreThan90Days"
          v-model="fields.hasAccountMoreThan90Days"
          name="hasAccountMoreThan90Days"
          label="A conta de luz está no seu nome há mais de 3 meses?"
          :validation="validation"
          @input="handleHasAccountMoreThan90Days"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'accountValueMoreThan80')"
          id="accountValueMoreThan80"
          key="accountValueMoreThan80"
          v-model="fields.accountValueMoreThan80"
          name="accountValueMoreThan80"
          label="O valor da sua conta de luz costuma ser maior que R$ 80,00?"
          :validation="validation"
          @input="handleHasAccountValueMoreThan80"
        />
        <RadioInputList
          v-if="displayInput(step, 'provider')"
          id="provider"
          v-model="fields.provider"
          class="field"
          title="Qual é a companhia elétrica da sua conta de luz?"
          name="provider"
          :validation="validation"
          :searchable="false"
          validations="required"
          :options="cptdElectricityProviders"
          @input="handleProvider"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'hasCrefazLoan')"
          id="hasCrefazLoan"
          key="hasCrefazLoan"
          v-model="fields.hasCrefazLoan"
          name="hasCrefazLoan"
          label="Você já tem um empréstimo com a Crefaz?"
          :validation="validation"
          @input="handleHasCrefazLoan"
        />
      </template>
    </InteractiveForm>
  </FormContainer>
</template>
<script>
import { nextTick } from 'vue'
import YesOrNoCheckInput from '~/components/forms/fields/checkInput/YesOrNoCheckInput.vue'
import RadioInputList from '~/components/ui/newComponents/RadioInputList.vue'
import InteractiveForm from '~/components/forms/InteractiveForm.vue'
import FormContainer from '~/containers/forms/FormContainer.vue'
import HowItWorks from '~/components/ui/HowItWorks.vue'
export default {
  name: 'CrefazPreSelectOfferModal',
  components: {
    FormContainer,
    InteractiveForm,
    RadioInputList,
    YesOrNoCheckInput,
    HowItWorks,
  },
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'submit', 'reject'],
  data() {
    return {
      fields: {
        acceptPaymentTerms: undefined,
        hasAccount: undefined,
        hasAccountMoreThan90Days: undefined,
        accountValueMoreThan80: undefined,
        provider: '',
        hasCrefazLoan: undefined,
      },
      displayNoResultFeedbackDialog: false,
      autoSelectableSteps: [
        'howItWorks',
        'acceptPaymentTerms',
        'hasAccount',
        'hasAccountMoreThan90Days',
        'accountValueMoreThan80',
        'provider',
        'hasCrefazLoan',
      ],
      steps: [
        'howItWorks',
        'acceptPaymentTerms',
        'hasAccount',
        'hasAccountMoreThan90Days',
        'accountValueMoreThan80',
        'provider',
        'hasCrefazLoan',
      ],
    }
  },
  computed: {
    cptdElectricityProviders() {
      return [
        'CPFL Paulista',
        'CPFL Piratininga',
        'CPFL Santa Cruz-MG',
        'CPFL Santa Cruz-PR',
        'CPFL Santa Cruz-SP',
        'RGE RS',
        'RGE Sul RS',
        'Enel RJ',
        'Enel CE',
        'Enel SP',
        'Celpe PE',
        'Coelba BA',
        'Cosern RN',
        'Elektro SP',
        'Elektro MS',
        'Outra companhia',
      ].map((name) => ({
        id: name,
        label: name,
        value: name,
      }))
    },
  },
  methods: {
    onBackClick() {
      this.$emit('close')
    },
    reject() {
      this.$emit('reject')
    },
    handleAcceptTerms(value) {
      if (!value) {
        this.reject()
        return
      }
      this.fields.acceptPaymentTerms = value
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    handleHasAccount(value) {
      if (!value) {
        this.reject()
        return
      }
      this.fields.handleHasAccount = value
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    handleHasAccountValueMoreThan80(value) {
      if (!value) {
        this.reject()
        return
      }
      this.fields.handleHasAccountValueMoreThan80 = value
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    handleHasAccountMoreThan90Days(value) {
      if (!value) {
        this.reject()
        return
      }
      this.fields.handleHasAccountMoreThan90Days = value
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    handleProvider(value) {
      if (value === 'Outra companhia') {
        this.reject()
        return
      }
      this.fields.handleProvider = value
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    handleHasCrefazLoan(value) {
      if (value) {
        this.reject()
        return
      }
      this.submit()
    },
    handleHowItWorks() {
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    displayInput(step, key) {
      return step === key
    },
    submit() {
      this.$emit('submit', this.fields)
    },
  },
}
</script>
<style lang="scss">
.CrefazPreSelectForm {
}
</style>
